import React, { useState, useEffect } from 'react';

import { Dropdown, FormCheckbox } from "components";

import { convertArrayToDropdownArrayFormat, func_validation, isStringEqual_caseInsensitive } from "functions";

export function useSideInputDisplay(props) {
    // Props

    const { 
        isEditing,
        advancePaySetup,
        
        isFormSubmissionAttempted, isCloning
    } = props;

    let statusList = [
        {
            label: "Confirmed",
            value: "Confirmed",
        },
        {
            label: "Pending",
            value: "Pending",
        },
        {
            label: "Completed",
            value: "Completed",
        },
        {
            label: "Inactive",
            value: "Inactive",
        },
    ];



    // validation
    let status_original = isCloning? "Pending": statusList[advancePaySetup?.BillStatus]?.value;
    let isBillInForeignCurrency_init = advancePaySetup?.IsBillInForeignCurrency;

    // States
    const [status, setStatus] = useState(status_original);
    const [isBillInForeignCurrency, setIsBillInForeignCurrency] = useState(isBillInForeignCurrency_init);
    const [isAnyInputChanged, setIsAnyInputChanged] = useState(false);

    // Check for changes in input from initial
    useEffect(() => {
        let isNotChangedFromOriginal = (
            status === status_original &&
            isBillInForeignCurrency === isBillInForeignCurrency_init
        );

        let isChangedFromEmpty = (
            status || isBillInForeignCurrency
        )

        setIsAnyInputChanged(isEditing? !isNotChangedFromOriginal: isChangedFromEmpty);   
    }, [
        status, isBillInForeignCurrency
    ]);
    
    // Display
    let display = (
        <div className={"right-section__side-inputs"}>
            {/* Status */}
            <Dropdown
                className={"side-inputs__status"}
                label={"Status"}
                isInputRequired

                selectedValueClassName={"status__input"}

                options={statusList}
                valueFromParent={status}
                selectedValue_default={status}
                onChange={setStatus}

                errorMsg={"Required"}

                isFormSubmissionAttempted={isFormSubmissionAttempted}
                isInputValueTrim_onChange
            />

            {/* Bill In Foreign Currency */}
            <div className={"side-inputs__is-bill-foreign-currency d-flex align-items-center justify-content-between"}>
                {/* Label */}
                <div className={"is-bill-foreign-currency__label"}>
                    Bill In Foreign Currency
                </div>
                
                <FormCheckbox
                    checkboxClassName={"is-bill-foreign-currency__checkbox"}
                    isCheckboxCheckedDefault={isBillInForeignCurrency_init}
                    handleCheckboxSelectionSub={(checkboxId, isChecked) => {
                        setIsBillInForeignCurrency(isChecked);
                    }}
                    
                    isCheckboxIconVisible
                />
            </div>

        </div>
    );

    let isEveryInputValid = (
        func_validation.isStringTrimNotEmpty(status)
    );

    let sideDetails = {
        BillStatus: status,
        IsBillInForeignCurrency: isBillInForeignCurrency,
    }

    return {
        sideDetails,
        isEveryInputValid,
        isAnyInputChanged,

        display
    }
}